import { Paper } from "@mui/material";
import type { PaperProps } from "@mui/material/Paper";
import type { ReactNode } from "react";

export function SectionCard({ children, ...props }: PaperProps & { children: ReactNode }) {
  return (
    <Paper variant="outlined" {...props} sx={{ p: { xs: 1.5, sm: 2 }, ...props.sx }}>
      {children}
    </Paper>
  );
}
